const CircleUnCheckIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
    >
      <circle
        cx="12"
        cy="12.5"
        r="11"
        fill="white"
        stroke="#B2B2B2"
        strokeWidth="2"
      />
    </svg>
  );
};

export default CircleUnCheckIcon;
